// extracted by mini-css-extract-plugin
export var editor = "_1k-0";
export var flowSidebar = "_52-2";